import { createFileRoute } from "@tanstack/react-router";
import { AiSkillsPage } from "~/pages/AiSkillsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/ai-skills")({
  component: AiSkillsPage,
});
